<template>
    <div class="meter-container pa-md-10">
        <v-toolbar
            flat
            dense
            v-if="meter !== null"
            class="name"
            height="100px"
            color="background"
        >
            <v-card class="ml-md-9 ml-2 mr-6">
                <v-card-text>
                    <v-icon color="primary">mdi-flash-circle</v-icon>
                </v-card-text>
            </v-card>

            <v-toolbar-title>
                {{ meter.circuit || meter.name }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu transition="slide-x-transition" bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="accent" small>
                        <v-icon>mdi-view-grid-plus</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="chartHandlerForm.open = !chartHandlerForm.open">
                        <v-list-item-icon>
                            <v-icon>mdi-finance</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Añadir grafica</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="widgetHandlerForm.open = !widgetHandlerForm.open">
                        <v-list-item-icon>
                            <v-icon>mdi-gauge</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Añadir widget</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn class="ml-2" color="accent" small>
                <v-icon>mdi-table-of-contents</v-icon>
            </v-btn>

            <v-btn class="mr-md-9 mr-2 ml-2" color="accent" small :disabled="!graphs.status" @click="saveChanges">
                <v-icon>mdi-content-save</v-icon>
            </v-btn>
        </v-toolbar>
        
        <v-row class="" v-if="meter !== null">
            <v-col
                class=""
                v-for="widget in graphs.widgets"
                :key="widget.id"
                sm="4"
                cols="12"
            >
                <GraphContainer 
                    :ref="widget.id"
                    :meter="meter" 
                    :graph="widget" 
                    @edit="widgetHandlerForm = { id: $event.id, open: true }"/>
            </v-col>
        </v-row>

        <v-row class="" v-if="meter !== null">
            <v-col
                class=""
                v-for="chart in graphs.charts"
                :key="chart.id"
                sm="6"
                cols="12"
            >
                <GraphContainer 
                    :ref="chart.id"
                    :meter="meter" 
                    :graph="chart" 
                    @edit="chartHandlerForm = { id: $event.id, open: true }"/>
            </v-col>
        </v-row>

        <formChart  
            v-if="meter !== null" 
            :id="chartHandlerForm.id"
            :meter="meter.name" 
            :open="chartHandlerForm.open" 
            @changes="changesCharts"
            @close="chartHandlerForm = { id: null, open: false }"
            />

        <formWidget  
            v-if="meter !== null" 
            :id="widgetHandlerForm.id"
            :meter="meter.name" 
            :open="widgetHandlerForm.open" 
            @changes="changesCharts"
            @close="widgetHandlerForm = { id: null, open: false }"
            />

        
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { GraphContainer } from "../components/graphs";
import Chart from "../components/graphs/modules/Chart";
import formChart from '../components/formChart'
import formWidget from '../components/formWidget'

export default {
    name: "Meter",
    components: { GraphContainer, formChart, formWidget },
    computed: {
        ...mapGetters({
            getMeter: "meters/getMeter",
            getGraphs: "graphs/getGraphs",
            getGraphStatus: "graphs/getStatus",
        }),
    },
    data() {
        return {
            meter: {
                name: this.$route.params.id
            },
            graphs: {
                status: false
            },
            chartHandlerForm: {
                id: null,
                open: false
            },
            widgetHandlerForm: {
                id: null,
                open: false
            }
        };
    },
    methods: {
        ...mapActions({ save: 'graphs/saveChanges' }),
        async saveChanges(){
            await this.save(this.meter.name)
            this.changesCharts()
        },
        refreshChart(id){
            this.$refs[id][0].refresh()
        },
        changesCharts(id) {
            this.chartHandlerForm = { id: null, open: false }
            this.widgetHandlerForm = { id: null, open: false } 

            if(id) return this.refreshChart(id)

            this.meter = this.getMeter(this.$route.params.id)
            if(!this.meter) return this.$router.push({ name: 'Home' })

            this.graphs = this.getGraphs(this.meter.name)
        }
    },
    watch: {
        "$route.params.id"() {
            this.changesCharts()
        },
    },
    mounted() {
        this.changesCharts()
    },
};
</script>

<style>
.meter-container {
    margin-top: 85px;
}
.name {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
}
</style>
